import { render, staticRenderFns } from "./GratitudesJournalMessageCard.vue?vue&type=template&id=75a6d5ef&scoped=true&"
import script from "./GratitudesJournalMessageCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GratitudesJournalMessageCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./GratitudesJournalMessageCard.vue?vue&type=style&index=0&id=75a6d5ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a6d5ef",
  null
  
)

export default component.exports